import { normalizeError } from '../../../operationFeedback/normalizeError';

export const trainingButton = 'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:cursor-not-allowed disabled:opacity-50';
export const trainingPrimary = `${trainingButton} !border-transparent !bg-[#1463C7] !text-white hover:!bg-[#0B3A78]`;
export const trainingDate = (value, language) => value && !Number.isNaN(Date.parse(value)) ? new Date(value).toLocaleString(language || undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '—';
export const cardKey = (card) => card.card_key || card.key || String(card.id);
export const assignmentGroup = (assignment) => {
  if (['completed', 'passed', 'exempt', 'withdrawn'].includes(assignment.status)) return 'completed';
  if (assignment.blocking) return 'required';
  if (assignment.recommended === true) return 'recommended';
  if (assignment.requirement === 'optional' || assignment.policy?.requirement === 'optional') return 'optional';
  return 'deadline';
};
export const trainingError = (error, t) => {
  const normalized = normalizeError(error);
  if (normalized.httpStatus === 409) return t('trainingParticipant.revisionChanged');
  if (normalized.httpStatus === 403 || normalized.httpStatus === 404) return t('trainingParticipant.accessChanged');
  const fields = normalized.fieldErrors?.map((field) => field.message).filter(Boolean);
  return fields?.length ? fields.join(' · ') : t('trainingParticipant.loadFailed');
};

// Unknown transport outcomes retain their original operation identity until reconciled.
export const uncertainTrainingOutcome = (error) => {
  const normalized = normalizeError(error);
  return normalized.httpStatus == null || normalized.httpStatus >= 500;
};
export const trainingReceiptCards = (evidence) => {
  const cards = evidence?.cards || evidence || {};
  return Array.isArray(cards) ? cards : Object.entries(cards).filter(([, value]) => value && typeof value === 'object').map(([key, value]) => ({ card_key: key, ...value }));
};

// Mirrors Training::Translations.localize on the API: text overlays keyed by page, card and option keys.
export const localizeTrainingPages = (pages, overlay) => {
  if (!overlay) return pages || [];
  return (pages || []).map((page) => ({
    ...page,
    title: overlay.pages?.[page.key]?.title || page.title,
    cards: (page.cards || []).map((card) => {
      const text = overlay.cards?.[cardKey(card)];
      if (!text) return card;
      return {
        ...card,
        ...Object.fromEntries(['title', 'body', 'explanation', 'image_alt'].map((field) => [field, text[field] || card[field]])),
        options: (card.options || []).map((option) => ({ ...option, text: text.options?.[option.id] || option.text })),
      };
    }),
  }));
};
// The course language first, then every language that has a translation.
export const trainingLocales = (contentLocale, translations) => {
  const base = contentLocale || 'nb';
  return [base, ...['nb', 'en', 'sv', 'pl'].filter((code) => code !== base && translations?.[code])];
};
